import React, { useEffect, useState } from "react";
import Card from "react-bootstrap/Card";
import { CardPublicProps } from "../type/interface";
import "./styles.css";

const CardPublic = (props: CardPublicProps) => {
  const {
    publicVideo: { provider, date, postcode, locality, address, name, insight },
  } = props;

  const getColorFromProvider = (provider: string) => {
    switch (provider) {
      case "sls":
        return "success";
      case "police":
        return "primary";
      case "uts":
        return "danger";
      case "ta":
        return "secondary";
    }
  };
  return (
    <Card
      bg={getColorFromProvider(provider)}
      text="white"
      style={{ width: "60%", margin: "auto" }}
      className="mb-3 mt-4"
      border="primary"
    >
      <Card.Header
        style={{
          backgroundColor: "rgba(0,0,0,0.1)",
          padding: "0.5rem 1.25rem",
          fontSize: "20px",
          borderBottom: "1px solid rgba(0,0,0,.125)",
        }}
      >
        {provider.toUpperCase()}
      </Card.Header>
      <Card.Body>
        <Card.Title style={{ color: "white" }}>{date}</Card.Title>
        <Card.Title style={{ color: "white" }}>{address}</Card.Title>
        {/* <Card.Title style={{ color: "white" }}>{name}</Card.Title> */}
        <Card.Title style={{ color: "white" }}>{insight}</Card.Title>
      </Card.Body>
    </Card>
  );
};

export default CardPublic;
